import React from 'react';
import { useTranslation } from 'react-i18next';

export const BootingScreen: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="login-screen" style={{ paddingLeft: "0.5em", paddingRight: "0.5em" }}>
            <img src="/logo.png" alt="App Logo" className="app-logo" />
            <h1>{t('main_component.initializing')}</h1>
            <div className="spinner" style={{
                margin: "2em auto",
                border: "6px solid #f3f3f3",
                borderTop: "6px solid #3498db",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                animation: "spin 1s linear infinite"
            }} />
            <style>
                {`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                        `}
            </style>
        </div>
    );
};